import Cookies from "js-cookie";
import { jwtDecode } from "jwt-decode";

export default {
  namespaced: true, // Aktifkan namespace untuk modular store

  state: {
    user: null, // Ambil data dari localStorage saat aplikasi dimulai
  },
  getters: {
    getUser: () => {
      return JSON.parse(localStorage.getItem("user")) || null;
    },
    getJwtToken: () => {
      return Cookies.get("token_jwt") || null; // Ambil token dari cookie
    },
  },

  mutations: {
    setUser(state, user) {
      localStorage.setItem("user", JSON.stringify(user)); // Simpan user di localStorage
    },

    setJwtToken(state, token) {
      Cookies.set("token_jwt", token, { expires: 7, path: "/" }); // Simpan token dengan masa berlaku 7 hari
    },

    removeJwtToken(state) {
      Cookies.remove("token_jwt"); // Hapus token dari cookie
      state.user = null;
      localStorage.removeItem("user"); // Hapus user dari localStorage
      window.location.href = `${process.env.VUE_APP_URL}login`;
    },
  },

  actions: {
    saveJwtToken({ commit }, token) {
      try {
        commit("setJwtToken", token);
        const user = jwtDecode(token);
        commit("setUser", user);
      } catch (error) {
        console.error("Token tidak valid:", error);
      }
    },

    logout({ commit }) {
      commit("removeJwtToken"); // Hapus token & user saat logout
    },
  },
};
